import { useEffect, useState } from "react";
import NavAdmin from "../../components/nav-admin/NavAdmin";
import theme from "../../theme";
import WrapperAdmin from "../admin/Admin.styles";
import { styled } from 'styled-components';
import { getActualPriceOfHighlight, getDocumentsByMonthAndYear, getAllDocuments } from "../../hooks/firebase";
import HouseAdvertisementCardAdmin from "../../components/house_advertisement_card-admin/HouseAdvertisementCard";
import { FaPlusCircle } from "react-icons/fa";
import Switch from 'react-ios-switch';

const WrapperCard = styled.div`
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 20px;

    .card-title {
        font-size: 20px;
        color: white;
    }

    .content {
        width: 60%;
        background-color: white;
        text-align: center;
        color: black;
        font-size: 30px;
        padding: 10% 20%;
        border-radius: 30px;
        font-family: ${theme.fontFamily.bold};
    }
`;

const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 10px;

    .filter-label {
        font-size: 14px;
        color: white;
    }

    .date-filters {
        display: flex;
        align-items: center;
        gap: 5px;
    }
`;

const AdminAnuncios = () => {
    const today = new Date();
    const months = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];

    const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);
    const currentMonth = months[today.getMonth()];
    const currentYear = today.getFullYear();
    const [month, setMonth] = useState(currentMonth); 
    const [year, setYear] = useState(currentYear);
    const [showAll, setShowAll] = useState(false);
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            let result;
            
            if (showAll) {
                result = await getAllDocuments();
            } else {
                const monthNumber = months.indexOf(month) + 1;
                result = await getDocumentsByMonthAndYear(monthNumber, year);
            }
            
            setData(result);
        };

        fetchData();
    }, [month, year, showAll]);

    return (
        <WrapperAdmin>
            <NavAdmin />
            <div className="main">
                <span className="header">
                    <span className="title">Anúncios</span>
                    <FilterContainer>
                        {showAll ? 
                            <span className="filter-label">Todos</span>
                            :
                            ""
                        }
                        <Switch
                            checked={!showAll}
                            onChange={() => setShowAll(!showAll)}
                            onColor={theme.fontColor.green}
                            offColor="#E5E5EA"
                        />
                        {!showAll && (
                            <>
                                <span className="filter-label">Filtrar</span>
                                <div className="date-filters">
                                    <select value={month} onChange={(e) => setMonth(e.target.value)}>
                                        {months.map((m) => (
                                            <option key={m} value={m}>{m}</option>
                                        ))}
                                    </select>
                                    /
                                    <select value={year} onChange={(e) => setYear(e.target.value)}>
                                        {years.map((y) => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>
                            </>
                        )}
                    </FilterContainer>
                </span>
                <div className="body">
                    {data !== null &&
                        data.map(property => (
                            <HouseAdvertisementCardAdmin 
                                key={property.id}
                                data={property}
                            />
                        ))
                    }
                </div>
            </div>
        </WrapperAdmin>
    );
};

export default AdminAnuncios;